import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className", "cssModule", "innerRef", "tag"];
import React from 'react';
import classNames from 'classnames';
import { mapToCssModules, tagPropType } from './utils';
var defaultProps = {
  tag: 'div'
};
var ToastBody = function ToastBody(props) {
  var className = props.className,
    cssModule = props.cssModule,
    innerRef = props.innerRef,
    Tag = props.tag,
    attributes = _objectWithoutPropertiesLoose(props, _excluded);
  var classes = mapToCssModules(classNames(className, 'toast-body'), cssModule);
  return /*#__PURE__*/React.createElement(Tag, _extends({}, attributes, {
    className: classes,
    ref: innerRef
  }));
};
ToastBody.defaultProps = defaultProps;
export default ToastBody;